import type { GenericLanguages } from '@payloadcms/translations'

export const i18n: Partial<GenericLanguages> = {
  ar: {
    label: 'فقرة',
    label2: 'نص عادي',
  },
  az: {
    label: 'Paraqraf',
    label2: 'Normal Mətn',
  },
  bg: {
    label: 'Параграф',
    label2: 'Нормален текст',
  },
  cs: {
    label: 'Odstavec',
    label2: 'Normální text',
  },
  da: {
    label: 'Afsnit',
    label2: 'Normal tekst',
  },
  de: {
    label: 'Paragraph',
    label2: 'Normaler Text',
  },
  en: {
    label: 'Paragraph',
    label2: 'Normal Text',
  },
  es: {
    label: 'Párrafo',
    label2: 'Texto normal',
  },
  et: {
    label: 'Paragrahv',
    label2: 'Tavaline tekst',
  },
  fa: {
    label: 'پاراگراف',
    label2: 'متن عادی',
  },
  fr: {
    label: 'Paragraphe',
    label2: 'Texte normal',
  },
  he: {
    label: 'פסקה',
    label2: 'טקסט רגיל',
  },
  hr: {
    label: 'Odlomak',
    label2: 'Normalan tekst',
  },
  hu: {
    label: 'Bekezdés',
    label2: 'Normál szöveg',
  },
  is: {
    label: 'Málsgrein',
    label2: 'Venjulegur texti',
  },
  it: {
    label: 'Paragrafo',
    label2: 'Testo normale',
  },
  ja: {
    label: '段落',
    label2: '通常のテキスト',
  },
  ko: {
    label: '문단',
    label2: '일반 텍스트',
  },
  my: {
    label: 'Perenggan',
    label2: 'ပုံမှန်စာသား',
  },
  nb: {
    label: 'Avsnitt',
    label2: 'Normal tekst',
  },
  nl: {
    label: 'Paragraaf',
    label2: 'Normale tekst',
  },
  pl: {
    label: 'Akapit',
    label2: 'Normalny tekst',
  },
  pt: {
    label: 'Parágrafo',
    label2: 'Texto Normal',
  },
  ro: {
    label: 'Paragraf',
    label2: 'Text normal',
  },
  rs: {
    label: 'Параграф',
    label2: 'Oбичан текст',
  },
  'rs-latin': {
    label: 'Paragraf',
    label2: 'Običan tekst',
  },
  ru: {
    label: 'Параграф',
    label2: 'Нормальный текст',
  },
  sk: {
    label: 'Odsek',
    label2: 'Normálny text',
  },
  sl: {
    label: 'Odstavek',
    label2: 'Navaden besedilo',
  },
  sv: {
    label: 'Stycke',
    label2: 'Normal Text',
  },
  ta: {
    label: 'பத்தி',
    label2: 'சாதாரண உரை',
  },
  th: {
    label: 'ย่อหน้า',
    label2: 'ข้อความธรรมดา',
  },
  tr: {
    label: 'Paragraf',
    label2: 'Normal Metin',
  },
  uk: {
    label: 'Абзац',
    label2: 'Звичайний текст',
  },
  vi: {
    label: 'Đoạn văn',
    label2: 'Văn bản bình thường',
  },
  zh: {
    label: '段落',
    label2: '正常文本',
  },
  'zh-TW': {
    label: '段落',
    label2: '正常文本',
  },
}
